var map = {
	"./dashboard.svg": "f782",
	"./example.svg": "30c3",
	"./exit-fullscreen.svg": "dbc7",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./form.svg": "eb1b",
	"./fullscreen.svg": "9921",
	"./link.svg": "18f0",
	"./nested.svg": "dcf8",
	"./password.svg": "2a3d",
	"./search.svg": "8e8d",
	"./table.svg": "47f1",
	"./tree.svg": "93cd",
	"./user.svg": "b3b5",
	"./zk-icon-Price-bundling.svg": "1400",
	"./zk-icon-activity.svg": "d121",
	"./zk-icon-binding.svg": "5203",
	"./zk-icon-cash.svg": "14fe",
	"./zk-icon-client-list.svg": "c6db",
	"./zk-icon-commodity-group.svg": "ecbb",
	"./zk-icon-commodity-set.svg": "603b",
	"./zk-icon-commodity.svg": "7e2c",
	"./zk-icon-coupon.svg": "2f5b",
	"./zk-icon-customer-details.svg": "e6e5",
	"./zk-icon-discount.svg": "fbff",
	"./zk-icon-finance-details.svg": "1207",
	"./zk-icon-finance.svg": "c8efb",
	"./zk-icon-generalize.svg": "ffc8",
	"./zk-icon-group-booking.svg": "5bbf",
	"./zk-icon-label.svg": "bd9a",
	"./zk-icon-logistics-set.svg": "a912",
	"./zk-icon-management-customer.svg": "e041",
	"./zk-icon-management-rule.svg": "effb",
	"./zk-icon-management-server.svg": "143b",
	"./zk-icon-marketing.svg": "04e4",
	"./zk-icon-material.svg": "f9bc",
	"./zk-icon-member.svg": "5f69",
	"./zk-icon-menu.svg": "ddb6",
	"./zk-icon-operation-plan.svg": "f374",
	"./zk-icon-operation-plan2.svg": "d036",
	"./zk-icon-order.svg": "ba67",
	"./zk-icon-pending-order.svg": "8e3c",
	"./zk-icon-sales-order.svg": "c5b1",
	"./zk-icon-scene.svg": "000a",
	"./zk-icon-seckill.svg": "554b",
	"./zk-icon-segmentation.svg": "5274",
	"./zk-icon-setting.svg": "c875",
	"./zk-icon-shop-decoration.svg": "34e4",
	"./zk-icon-spell-group.svg": "a124",
	"./zk-icon-store-set.svg": "c115",
	"./zk-icon-store.svg": "a8e4",
	"./zk-icon-system.svg": "a2a0",
	"./zk-icon-user.svg": "6b92",
	"./zk-icon-wallet.svg": "0489"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";